import System from '..'
const signalR = require('@microsoft/signalr')

// Netsis sağlık durumunu backend'deki /netsisstatushub üzerinden dinler.
// Backend 5sn'de bir Netsis'i pingler ve "updateNetsisStatus" event'i ile snapshot yayınlar.
export class NetsisStatusR {
    connection = null
    onUpdate = null
    onStateChange = null

    constructor(handlers = {}) {
        this.onUpdate = handlers.onUpdate || null
        this.onStateChange = handlers.onStateChange || null
        this.Configure()
    }

    Configure() {
        this.Connect()
            .then(() => this.Listen())
            .catch(() => this.NotifyState('disconnected'))
    }

    Connect() {
        return new Promise((resolve, reject) => {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(System.BaseURL.URL + '/netsisstatushub', {
                    transport: signalR.HttpTransportType.LongPolling,
                })
                .withAutomaticReconnect()
                .build()

            this.connection.onreconnecting(() => this.NotifyState('reconnecting'))
            this.connection.onreconnected(() => this.NotifyState('connected'))
            this.connection.onclose(() => this.NotifyState('disconnected'))

            this.connection.start().then(() => {
                System.Development ? console.log('SignalR Connected For Netsis Status') : null
                this.NotifyState('connected')
                resolve()
            }).catch((err) => reject(err))
        })
    }

    Listen() {
        this.connection.on('updateNetsisStatus', (snapshot) => {
            if (typeof this.onUpdate === 'function') this.onUpdate(snapshot)
        })
    }

    NotifyState(state) {
        if (typeof this.onStateChange === 'function') this.onStateChange(state)
    }

    Stop() {
        if (this.connection) {
            this.connection.stop().catch(() => {})
            this.connection = null
        }
    }
}
